import { handleClick } from "../utils/action.js";
import { AsYouType, getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js'
import { getFlagUrl } from "../utils/formatting.js";

class SonikitContact extends HTMLElement {
  #shadow

  constructor() {
    super();
    this.#shadow = this.attachShadow({ mode: 'closed' });
  }

  set patch(data) {
    this._patch = data;
    this.render();
  }

  set parentPatch(data) {
    this._parentPatch = data;
  }

  set service(data) {
    this._service = data;
  }
  
  reset() {
    dialog.close();
    this._service = null;
    // modal.dataset.status = 'idle';
  
    // const error_message = modal.querySelector('.contact-error');
    // const inputs = modal.querySelectorAll('input');
    // for (const input of inputs) {
    //   if (input.type === 'checkbox') {
    //     input.checked = false;
    //   } else {
    //     input.value = '';
    //   }
  
    //   error_message.style.display = "none";
    //   error_message.innerHTML = "";
    // }
  }

  async render() {
    let dataPolicy, skipButton;
    if (this._patch.data_policy && this._patch.data_policy !== '') {
      dataPolicy = this._patch.data_policy;
    } else {
      dataPolicy = `
        I agree to receive news, tour dates, special announcements, and more
        and agree to Sonikit's <a href="https://www.sonikit.com/privacy" target="_blank">Terms of Service</a> and <a href="https://www.sonikit.com/privacy" target="_blank">Privacy Policy</a>.
      `
    }

    if (this._parentPatch) {
      skipButton = `
        <button type="button" data-layout="text" data-role="skip">
          Skip <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>
        </button>
      `
    }

    const template = document.createElement('template');
    template.innerHTML = `
      <style>
        .wrapper {
          font-family: Arial, Helvetica, sans-serif;
          max-width: 400px;
          margin: auto;
        }
        .content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }
        .title {
          text-align: center;
          font-size: 1.2em;
        }
        .consent {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 6px;
          font-size: 0.7em;
          text-align: left;
        }
        .consent input{
          position: relative;
          margin: 0;
          padding: 0;
          appearance: none;
          width: 16px;
          height: 16px;
          flex: 0 0 16px;
          border: 0.15em solid grey;
          border-radius: 0.15em;
          outline: none;
        }
        .consent input::before {
          content: "";
          position: absolute;
          width: 70%;
          height: 70%;
          top: 50%;
          left: 50%;
          transform: translateY(-50%) translateX(-50%) scale(0);
          transform-origin: center;
          transition: 120ms transform ease-in-out;
          background-color: black;
        }
        .consent input:checked::before {
          transform: translateY(-50%) translateX(-50%) scale(1) ;
        }

        button {
          display: flex;
          flex: 1 1 auto;
          justify-content: center;
          align-items: center;
          gap: 5px;
          text-align: center;
          text-transform: uppercase;
          font-weight: 700;
          box-sizing: border-box;
          padding: 8px 16px;
          border-radius: 50px;
          cursor: pointer;
          border: none;
          color: white;
          background-color: black;
        }

        button, button:focus {
          outline: none;
        }

        @media (max-width: 500px) {
          button {
            width: 100%;
          }
        }

        .wrapper[data-layout="stacked"] button{
          width: 100%;
          max-width: 300px;
        }
        
        button svg {
          width: 1.2em;
          height: 1.2em;
          fill: currentColor;
          pointer-events: none;
        }

        button[data-layout='text'] {
          background-color: transparent;
          color: black;
          font-weight: 800;
          padding: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px;
          border: none;
          outline: none;
          cursor: pointer;
        }

        .form-block {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin: 0;
        }

        .input-wrap {
          position: relative;
          width: 100%;
          border: 1px solid black;
          border-radius: 50px 10px 10px 50px;
          overflow: hidden;
        }

        .input-wrap input{
          width: 100%;
          font-size: 1em;
          padding: 10px 10px 10px 80px;
          box-sizing: border-box;
          outline: none;
          border: none;
        }
        .input-wrap input[type="tel"]{
          padding: 10px 10px 10px 110px;
        }
        .input-toggle {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: calc(4em + 8px);
          background-color: #E4E7ED;
          border-radius: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .input-toggle__icons {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          padding: 0 11px 0 12px;
          box-sizing: border-box;
          align-items: center;
          pointer-events: none;
        }
        .input-toggle__icons svg{
          pointer-events: none;
          width: 1.2em;
          height: 1.2em;
        }

        .country-icon {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 78px;
          width: 24px;
        }
        .input-wrap[data-mode="email"] .country-icon{
          display: none;
        }
        .country-icon[data-validated="true"] svg{
          display: none;
        }
        .country-icon[data-validated="false"] svg{
          display: block;
        }
        .country-icon[data-validated="false"] #flag{
          display: none;
        }


        .input-toggle input[type="checkbox"] {
          appearance: none;
          position: absolute;
          width: 0;
          height: 0;
          z-index: -9999;
          visibility: hidden;
        }
        .input-toggle label {
          position: relative;
          width: 100%;
          height: 100%;
          border-radius: 50px;
          background-color: #E4E7ED;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding: 0px 4px;
          cursor: pointer;
          transition: background-color 300ms ease;
        }
        .input-toggle label::before {
          content: '';
          width: 2.15em;
          height: 2.15em;
          border-radius: 50%;
          background-color: white;
          box-shadow: 0 0 0 1px #8898aa1a;
          margin-right: 0;
          transition: margin-right 300ms ease;
        }
        .input-toggle input[type="checkbox"]:checked + label::before {
          margin-right: calc(100% - 2.15em); 
          transition: margin-right 300ms ease;
        }
        .submit {
          position: absolute;
          top: 0;
          right: 0;
          height: 100%;
          border-radius: 0 2px 2px 0;
        }

        a {
          color: black;
          font-weight: 600;
        }

        #error {
          font-size: 0.7em;
          color: red;
        }

        .loader {
          display: none;
          width: 200px;
          height: 200px;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 20px;
        }
        .loader svg{
          width: 40px;
          height: 40px;
          animation: rotate 2s linear infinite;
        }
        .loader circle {
          stroke: #000000;
          stroke-linecap: round;
          animation: dash 1.5s ease-in-out infinite;
        }
        @keyframes rotate {
          100% {
            transform: rotate(360deg);
          }
        }
        @keyframes dash {
          0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
          }
          50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
          }
          100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
          }
        }
        .wrapper[data-status="loading"] .loader {
          display: flex;
        }
        .wrapper[data-status="loading"] .content {
          display: none;
        }
      </style>
      <div class="wrapper">
        <div class="content">
          <div class="title">
            Sign up for <span id="contact-type-cta">text</span> updates:
          </div>
          <form id="contact-form" class="form-block">
            <div class="input-wrap" data-mode="phone">
              <div class="country-icon" data-validated="true">
                <img id="flag" src="http://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg" alt="flag" />
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z"/></svg>
              </div>
              <div class="input-toggle">
                <input id="contact-type" name="contact_type" type="checkbox" checked /><label for="contact-type"></label>
                <div class="input-toggle__icons">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M320-520q17 0 28.5-11.5T360-560q0-17-11.5-28.5T320-600q-17 0-28.5 11.5T280-560q0 17 11.5 28.5T320-520Zm160 0q17 0 28.5-11.5T520-560q0-17-11.5-28.5T480-600q-17 0-28.5 11.5T440-560q0 17 11.5 28.5T480-520Zm160 0q17 0 28.5-11.5T680-560q0-17-11.5-28.5T640-600q-17 0-28.5 11.5T600-560q0 17 11.5 28.5T640-520ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"/></svg>
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"/></svg>
                </div>
              </div>
              <button type="submit" class="submit">Sign up</button>
            </div>
            <span id="error"></span>
            <div class="consent">
              <input type="checkbox" name="contact-consent" required />
              <div class="consent__policy">
                ${dataPolicy}
              </div>
            </div>
            ${skipButton ? skipButton : ''}
          </form>
        </div>
        <div class="loader">
          <svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>
          Processing request...
        </div>
      </div>
    `

    this.#shadow.appendChild(template.content.cloneNode(true));
    
    if (this._parentPatch) {
      const skipButton = this.#shadow.querySelector('[data-role="skip"]');
      skipButton.addEventListener('click', () => handleClick(this._parentPatch, this._service));
    }

    const contactType = this.#shadow.querySelector('input[name="contact_type"]');
    const inputWrap = this.#shadow.querySelector('.input-wrap');








    let validationTimeout;

    function debounceValidation(callback, delay = 1000) {
      clearTimeout(validationTimeout)
      validationTimeout = setTimeout(callback, delay)
    }

    const validationMsg = this.#shadow.getElementById('error')
    function validatePhoneNumber(input, country) {
      const phoneNumber = parsePhoneNumberFromString(input, country)
    
      if (phoneNumber && !phoneNumber.isValid()) {
        validationMsg.textContent = '';
      } else {
        validationMsg.textContent = 'Please add a valid phone number';
      }
    }

    
    async function getUserCountry() {
      try {
        const res = await fetch('https://ipapi.co/json/')
        const data = await res.json()
        return data.country_code // e.g., "US"
      } catch (err) {
        console.error('Failed to fetch user country', err)
        return 'US' // fallback
      }
    }
    let defaultCountry = 'US';
    getUserCountry().then((country) => {
      defaultCountry = country
    })

    const countryIcon = this.#shadow.querySelector('.country-icon');
    const flagImg = this.#shadow.getElementById('flag');
    const phoneInput = document.createElement('input');
    phoneInput.type = 'tel';
    phoneInput.placeholder = 'Your phone number...';
    phoneInput.addEventListener('input', (e) => {
      const value = e.target.value;
      const formatter = new AsYouType(defaultCountry);
      e.target.value = formatter.input(value);

      const detectedCountry = formatter.getCountry(value);
      if (detectedCountry) {
        countryIcon.dataset.validated = "true";
        flagImg.src = getFlagUrl(detectedCountry)
      } else {
        countryIcon.dataset.validated = "false";
        flagImg.src = ''
      }

      debounceValidation(() => {
        validatePhoneNumber(value, detectedCountry || defaultCountry)
      }, 1000)
    })

    phoneInput.addEventListener('blur', () => {
      const number = parsePhoneNumberFromString(phoneInput.value, 'US');
      if (number && number.isValid()) {
        console.log('Valid number:', number.number);
      } else {
        console.log('Invalid phone number');
      }
    });

    const emailInput = document.createElement('input');
    emailInput.type = 'email';
    emailInput.placeholder = 'Your email address...';

    inputWrap.prepend(phoneInput);
    contactType.addEventListener('change', e => {
      if (e.target.checked) {
        emailInput.remove();
        inputWrap.prepend(phoneInput);
        inputWrap.dataset.mode = 'phone';
      } else {
        phoneInput.remove();
        inputWrap.prepend(emailInput);
        inputWrap.dataset.mode = 'email';
      }
    })
    
    const contactForm = this.#shadow.querySelector('#contact-form');
    contactForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const wrapper = this.#shadow.querySelector('.wrapper');
      wrapper.dataset.status = 'loading';
      const contact = await addContact(contactForm);
      if (contact.error) {
        wrapper.dataset.status = 'error';
        return console.log(contact.error);
      }
      
      if (this._parentPatch) {
        handleClick(this._parentPatch, this._service);
      }
    })
  }
}

async function addContact(form) {
  const body = {}
  const inputs = form.querySelectorAll('input');
  
  for (const input of inputs) {
    if (!input.value || input.value === '' || (input.type === 'checkbox' && !input.checked)) {
      return { error: "Please complete all fields." };
    } else {
      body[input.name] = input.value;
    }
  }

  if (body.email) body.consent_email = true;
  if (body.phone) body.consent_sms = true;
  
  const response = await fetch(`${sonikit.base_url}/js/temp-contact`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${sonikit.project.id}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })

  if (!response.ok) return { error: `Unable to add contact: ${response.status}`};
  const data = await response.json();
  
  sonikit.storage.contact_id = data.id;
  sonikit.storage.contact_token = data.token;
  localStorage.setItem('sonikit-store', JSON.stringify(sonikit.storage));
  return data;
}

customElements.define('sonikit-contact', SonikitContact);